//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
export default {
  name: 'SearchSelect',
  props: {
    options: {
      type: Array,
      default: null
    },
    dropdown: {
      type: Boolean,
      default: null
    }
  },
  data () {
    return {
      viewDropdown: false,
      search: null
    }
  },
  computed: {
    ...mapGetters({
      getSymbolFaName: 'coins/getSymbolFaName'
    }),
    filteredOption () {
      return this.options.filter((item) => {
        if (this.$route.path.startsWith('/coins')) {
          return item.symbol.includes(this.search.toUpperCase()) || (this.getSymbolFaName(item.symbol) ? this.getSymbolFaName(item.symbol).includes(this.search) : null)
        } else {
          return item.includes(this.search.toUpperCase()) || (this.getSymbolFaName(item) ? this.getSymbolFaName(item).includes(this.search) : null)
        }
      })
    }
  },
  watch: {
    dropdown (val) {
      this.viewDropdown = val
    }
  },
  methods: {
    selectOption (option) {
      this.search = null
      this.viewDropdown = false
      this.$emit('selectOption', option)
    }
  }
}
